import { BetQLSportItem } from "./";

const GOLFConfig: BetQLSportItem = {
  id: "91b1c949-a1c6-41d4-8975-8077dfeaa0de",
  name: "Golf",
  url: "golf",
  tabName: "Golf",
  icon: "golf",
  imagePath: "GOLF",
  key: "GOLF",
  lookupKey: "golf",
  favoriteLine: "moneyline",
  hasTeamPowerProjectionGrades: false,
  hasFGspreadPowerRating: false,
  hasFGmoneylinePowerRating: false,
  hasFGtotalPowerRating: false,
  has1HspreadPowerRating: false,
  has1HmoneylinePowerRating: false,
  has1HtotalPowerRating: false,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: false,
  hasInjuries: false,
  hasNews: false,
  hasLineup: false,
  hasSchedule: false,
  hasConfiguredSchedule: false,
  hasTeamSummary: false,
  hasGameFilters: false,
  hasStadium: false,
  hasLocation: false,
  hasTeamRecord: false,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: false,
  hasDraws: false,
  hasSharpData: false,
  hasTopTrendsData: false,
  hasPlayerProps: false,
  hasRecommendedBets: false,
  hasPopularEvents: false,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,4,9,5,14]}',
  defaultColumnOrder: [2, 4, 9, 5, 14],
  publicThreshold: 60,
  sharpPercentThreshold: 25,
  sharpCountThreshold: 300,
  publicCountThreshold: 300,
  trendTypes: [
    { name: "Moneyline", key: "ml", url: "moneyline-odds" },
    { name: "Spread", key: "ats", url: "ats-odds" },
  ],
  filters: [
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline-odds",
    },
    {
      name: "Spread",
      key: "spread",
      url: "ats-odds",
    },
    {
      name: "Total",
      key: "total",
      url: "over-unders",
    },
  ],
  periods: ["FULLGAME"],
  periodKeys: ["FG"],
  pickTypes: ["moneyline", "spread", "total"],
};

export default GOLFConfig;
